import { render, staticRenderFns } from "./RightTurn.vue?vue&type=template&id=15605988&scoped=true"
import script from "./RightTurn.vue?vue&type=script&lang=ts"
export * from "./RightTurn.vue?vue&type=script&lang=ts"
import style0 from "./RightTurn.vue?vue&type=style&index=0&id=15605988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15605988",
  null
  
)

export default component.exports